import { currentLang } from "../../../../_metronic/i18n/Metronici18n"

const AUTH_LOCAL_STORAGE_KEY = "kt-auth-react-v";
const getAuth = (): any | undefined => {
  if (!localStorage) {
    return;
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  if (!lsValue) {
    return;
  }

  try {
    const auth: any = JSON.parse(lsValue) as any;
    if (auth) {
      return auth;
    }
  } catch (error) {
    console.error("AUTH LOCAL STORAGE PARSE ERROR", error);
  }
};

const setAuth = (auth: any) => {
  if (!localStorage) {
    return;
  }

  try {
    const lsValue = JSON.stringify(auth);
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue);
  } catch (error) {
    console.error("AUTH LOCAL STORAGE SAVE ERROR", error);
  }
};

const removeAuth = () => {
  if (!localStorage) {
    return;
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
  } catch (error) {
    console.error("AUTH LOCAL STORAGE REMOVE ERROR", error);
  }
};

export function getAuthHeaders(): Record<string, string> {
  const auth = getAuth();
  if (auth?.accessToken) {
    return { authorization: `${auth.accessToken}` };
  }
  return {};
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = "application/json";
  axios.defaults.headers["lang"] = currentLang();
  axios.interceptors.request.use(
    (config: { headers: { Authorization: string } }) => {
      const auth = getAuth();
      if (auth && auth?.accessToken) {
        config.headers.Authorization = `${auth?.accessToken}`;
      }
      return config;
    },
    (err: any) => Promise.reject(err)
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      // Only force logout on auth failure. Permission denials (403) must not
      // wipe the session — virtual users refresh permissions and stay signed in.
      if (status === 401) {
        localStorage.clear();
        window.location.href = "/";
      }
      return Promise.reject(error);
    }
  );
}

export { getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY };
